import PolicyPage from "../components/PolicyPage";
export default function Cookies() { return <PolicyPage namespace="privacy" documentKey="cookieNotice" />; }
